import { rei } from "@/services/api"

class CumprimentoPedidosService {
  static gerarRelatorioCumprimentoPedidos (impressao) {
    const options = {
      responseType: 'arraybuffer'
    }

    return rei.post(`impressao/relatorio/cumprimento-pedidos`, impressao, options)
      .then(response => {
        let blob = new Blob([response.data], { type: 'application/pdf' })
        let url = window.URL.createObjectURL(blob)

        return url
      })
  }
}

export default CumprimentoPedidosService
